// Exports a single Auth instance.
// Features depend on this module (not on 'firebase/auth' directly),
// satisfying the Dependency Inversion principle.

import { getAuth, type Auth } from 'firebase/auth'
import { app } from './app'

const auth: Auth = getAuth(app)

export { auth }
